import { formatInTimeZone } from 'date-fns-tz';

export const formatTime = (date: Date | string): string => {
  return formatInTimeZone(new Date(date), 'Asia/Manila', 'HH:mm:ss');
};

export const formatDateTime = (date: Date | string | number): string => {
  return formatInTimeZone(new Date(date), 'Asia/Manila', 'MMM dd, yyyy HH:mm');
};

export const formatChartTime = (date: Date | string | number | null | undefined): string => {
  try {
    // Handle null/undefined
    if (date === null || date === undefined) {
      return '';
    }

    // Handle empty strings
    if (typeof date === 'string' && date.trim() === '') {
      return '';
    }

    let dateObj: Date;

    // Handle numeric timestamps (both number and string numbers)
    if (typeof date === 'number') {
      dateObj = new Date(date);
    } else if (typeof date === 'string') {
      // Check if it's a numeric string
      if (/^\d+$/.test(date.trim())) {
        const numValue = parseInt(date.trim(), 10);
        dateObj = new Date(numValue);
      } else {
        // Try parsing as ISO string or other date format
        dateObj = new Date(date);
      }
    } else {
      dateObj = new Date(date);
    }

    // Validate the date
    if (isNaN(dateObj.getTime()) || dateObj.getTime() === 0) {
      return '';
    }

    // Format using timezone
    return formatInTimeZone(dateObj, 'Asia/Manila', 'HH:mm');
  } catch (error) {
    // Silent fail - don't log every error to avoid console spam
    return '';
  }
};

export const formatValue = (value: number | null | undefined, decimals: number = 1): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return '--';
  }
  return value.toFixed(decimals);
};

export const getWeatherCondition = (data: {
  temperature: number | null;
  humidity: number | null;
  pressure: number | null;
  light: number | null;
  rain: number | null;
  windSpeed: number | null;
}): string => {
  const { temperature, humidity, light, rain } = data;
  
  // Priority-based weather classification
  if (rain !== null && rain > 50) return 'rainy';
  if (light !== null && light < 20) return 'foggy';
  if (temperature !== null && temperature > 35) return 'hot';
  if (temperature !== null && temperature < 15) return 'cold';
  if (light !== null && light > 80 && humidity !== null && humidity < 50) return 'sunny';
  if (light !== null && light < 40) return 'cloudy';
  if (light !== null && light >= 40 && light <= 80) return 'partly-cloudy';
  
  return 'unknown';
};
